import React from "react";

export default function Logo({ size = 32, withText = true, textClass = "" }) {
  return (
    <div className="flex items-center gap-2.5">
      <img src="/brand/tonneva-logo.png" alt="Tonneva" style={{ width: size, height: size }} className="object-contain" />
      {withText && (
        <span className={`font-heading font-bold tracking-tight ${textClass || "text-lg"}`} style={{ color: "var(--tonneva-primary-dark, #1d6781)" }}>
          Tonneva
        </span>
      )}
    </div>
  );
}
